export default "__VITE_ASSET__DE5TBAhG__"